/*
 * Yandex.Metrika counter, europe only.
 *
 * Russia's counter is in index.html and loads on first paint, as it always has. Europe's follows
 * the same rule as utils/googleTagManager.js: nothing non-essential before the cookie banner is
 * answered, so the counter starts only once the visitor allows analytics.
 *
 * The snippet's <noscript> pixel is left out for the same reason GTM's iframe is: with scripting off
 * there is no banner, so it could not honour a refusal.
 */

import { IS_EUROPE, METRIKA_ID } from '../config/region';
import { allows, onConsentChange } from './consent';

/* Where the counter reads ecommerce pushes from (utils/ecommerce.js writes them). Not `dataLayer`:
   in europe that array belongs to Google Tag Manager, which would read Metrica's `ecommerce`
   objects as its own. Russia has no GTM and keeps the counter's default name. */
export const METRIKA_DATA_LAYER = IS_EUROPE ? 'ymDataLayer' : 'dataLayer';

let started = false;

const startCounter = () => {
  if (started) return;
  started = true;

  window.ym = window.ym || function () { (window.ym.a = window.ym.a || []).push(arguments); };
  window.ym.l = 1 * new Date();

  const s = document.createElement('script');
  s.async = true;
  s.src = `https://mc.yandex.ru/metrika/tag.js?id=${METRIKA_ID}`;
  document.head.appendChild(s);

  window.ym(METRIKA_ID, 'init', {
    ssr: true, webvisor: true, clickmap: true, ecommerce: METRIKA_DATA_LAYER,
    referrer: document.referrer, url: window.location.href,
    accurateTrackBounce: true, trackLinks: true,
  });
};

/* Returns an unsubscribe function, or undefined when there is nothing left to wait for. */
export const initYandexMetrika = () => {
  if (!IS_EUROPE) return undefined;
  if (allows('analytics')) {
    startCounter();
    return undefined;
  }
  return onConsentChange((consent) => {
    if (consent.analytics) startCounter();
  });
};
